import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Circle from './Circle';
import Hidden from '@material-ui/core/Hidden';
import Typography from '@material-ui/core/Typography';
import { ACCESS_MARK_MAX_WIDTH, ACCESS_MARK_POINT_SIZE } from './variables';

const useStyles = makeStyles((theme) => ({
  circleRoot: {
    border: 'none',
    backgroundColor: theme.palette.primary.light,
  },
  box: {
    display: 'flex',
    alignItems: 'center',
  },
  point: {
    width: ACCESS_MARK_POINT_SIZE,
    height: ACCESS_MARK_POINT_SIZE,
    borderRadius: '50%',
    backgroundColor: theme.palette.primary.light,
  },
  text: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 'bold',
    marginLeft: theme.spacing(1),
  },
}));

const AccessMark = ({ children }) => {
  const classes = useStyles();
  return (
    <>
      <Hidden implementation="css" smDown>
        <div
          style={{
            width: '100%',
            maxWidth: ACCESS_MARK_MAX_WIDTH,
            margin: 'auto',
          }}
        >
          <Circle classes={{ root: classes.circleRoot }}>{children}</Circle>
        </div>
      </Hidden>
      <Hidden implementation="css" mdUp>
        <div className={classes.box}>
          <div className={classes.point} />
          <Typography className={classes.text}>{children}</Typography>
        </div>
      </Hidden>
    </>
  );
};

export default AccessMark;
